/**
 * Paths
 * @enum - Paths for router
 */
enum Paths {
  /** Home page */
  Home = '/',
  /** Login screen */
  Login = '/login',
  /** Login callback */
  LoginCallback = '/login/callback',
  /** Change password screen */
  ChangePassword = '/change-password',
  /** Help screen */
  Help = '/help',
  /** Dashboards root */
  Reports = '/reports',
  /** Individual Dashboards */
  Report = '/reports/:reportId',
  /** Fan Segmentation */
  Segments = '/segments',
  /** New Fan Segmentation */
  NewSegment = '/segments/create',
  /** Single Fan Segment */
  Segment = '/segments/:segmentId',
  /** Segmant Pushes */
  SegmentPushes = '/segments/:segmentId/pushes',
  /** Segmant Dependencies */
  SegmantDependencies = '/segments/:segmentId/dependencies',
  /** Push Segmant */
  PushSegment = '/segments/:segmentId/pushes/push-segment',
  /** Push Details */
  PushDetails = '/segments/:segmentId/pushes/:pushId',
  /** Management screen */
  Management = '/management',
  /** Support screen */
  Support = '/support',
  /** Add Request screen */
  AddRequest = '/support/add-request',
  /** Clients Overview */
  Clients = '/clients',
  /** Add Client screen */
  AddClient = '/clients/create',
  /** Edit Client screen */
  EditClient = '/clients/:clientId/edit',
  /** Edit Client Dashboards screen */
  ClientDashboards = '/clients/:clientId/edit/dashboards',
  /** Add Dashboard screen */
  AddClientDashboard = '/clients/:clientId/edit/dashboards/create',
  /** Edit Dashboard screen */
  EditClientDashboard = '/clients/:clientId/edit/dashboards/:dashboardId/edit',
  /** Edit Client Announcements screen */
  ClientAnnouncements = '/clients/:clientId/edit/announcements',
  /** Edit Client Tags screen */
  ClientTags = '/clients/:clientId/edit/tags',
  /** Edit Client Navigation screen */
  ClientNavigation = '/clients/:clientId/edit/navigation',
  /** User Management screen */
  Users = '/users',
  /** Add User screen */
  AddUser = '/users/create',
  /** Edit User screen */
  EditUser = '/users/:userId/edit',
  /** View/Edit global help documents */
  GlobalHelpDocuments = '/global-help',
  /** Add global help documents */
  AddGlobalHelpDocument = '/global-help/create',
  /** Edit global help documents */
  EditGlobalHelpDocument = '/global-help/:snippetId/edit',
  /** View global help documents revisions */
  ViewGlobalHelpDocumentRevisions = '/global-help/:snippetGroupId/revisions',
  /** View/Edit client help documents */
  ClientHelpDocuments = '/clients/:clientId/edit/help',
  /** Add client help documents */
  AddClientHelpDocument = '/clients/:clientId/edit/help/create',
  /** Edit client help documents */
  EditClientHelpDocument = '/clients/:clientId/edit/help/:snippetId/edit',
  /** View client help documents revisions */
  ViewClientHelpDocumentRevisions = '/clients/:clientId/edit/help/:snippetGroupId/revisions',
  /** Announcements Screen */
  Announcements = '/announcements',
  /** Client Users Table */
  ClientUsers = '/clients/:clientId/edit/users',
  /** Edit client snowflake configuration */
  SnowflakeConfiguration = '/clients/:clientId/edit/snowflake'
}

export default Paths;
